import { Lock } from 'lucide-react';

interface TfaLockBannerProps {
  lockedAt: string | null;
  lockedByName: string | null;
  lockedByRole: string | null;
}

export function TfaLockBanner({ lockedAt, lockedByName, lockedByRole }: TfaLockBannerProps) {
  if (!lockedAt || !lockedByName) return null;

  const date = new Date(lockedAt);
  const formattedDate = date.toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  });
  const formattedTime = date.toLocaleTimeString('en-AU', {
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
    timeZone: 'UTC',
  });

  return (
    <div className="flex items-center gap-2 rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-800 dark:border-green-900 dark:bg-green-950 dark:text-green-300">
      <Lock className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>
        Locked on <strong>{formattedDate}</strong> at <strong>{formattedTime}</strong> by{' '}
        <strong>{lockedByName}</strong>
        {lockedByRole && <span className="text-green-600 dark:text-green-400"> ({lockedByRole})</span>}
      </span>
    </div>
  );
}
